import type { ConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { FileAssetsDataObject, FolderAssetDataObject, ListAssetsRequest } from 'models/service';

export const listAssets = async ({ config }: ConfigRequest<ListAssetsRequest>) =>
  apiClient.get<
    Array<FileAssetsDataObject | FolderAssetDataObject>,
    ApiClientResponse<Array<FileAssetsDataObject | FolderAssetDataObject>>
  >(routes.assets.list, config);
